import React from "react";

export function FacebookIcon({ className }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2462_5454)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13.032 5.07031H15.2472H15.2483V7.46091C15.1215 7.46165 14.7442 7.46138 14.3988 7.46113C14.2375 7.46102 14.0831 7.46091 13.9644 7.46091C13.9627 7.46091 13.9602 7.46086 13.9569 7.46079C13.8639 7.45887 13.1337 7.44386 13.1337 8.17082C13.1384 8.47839 13.1337 9.53751 13.1337 9.53751H15.257L15.0849 11.9184H13.1833V18.9313H10.3023V11.9644H8.73438V9.5443H10.2552C10.2552 9.30067 10.2559 9.06629 10.2567 8.83689C10.2581 8.39244 10.2594 7.96672 10.2552 7.52878C10.2552 5.62322 11.7174 5.07031 13.032 5.07031Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
